module.exports = __webpack_public_path__ + "img/image (14).3dd78a9a.png";